import styled from "styled-components";

export const MainContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #262626;
  overflow: hidden;

  position: relative;
`;


export const TopBarThing = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 70px;
  z-index: 1;
  background-color: var(--bg-light-blue);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: end;
`;

export const Greece1600 = styled.div`
  grid-column-start: 2;
  justify-self: center;
  background-color: var(--bg-dark-blue);
  color: var(--highlight) !important;

  padding: 30px 40px 10px;
  border-radius: 0 0 10px 10px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MapContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: #262626;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;
`;


export const Map = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* or 'contain' if you want full map visible */
  z-index: 0;
`;


export const PlayerBanner = styled.div`
  width: 200px;
  height: 378px;
  background-color: var(--bg-dark-blue);

  position: fixed;
  bottom: 0;
  right: 2.4%;

  border-radius: 10px 10px 0 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;

  z-index: 4;
`;

export const PlayerEmblem = styled.div`
  width: 84px;
  height: 84px;
  border: 3px solid var(--highlight);
  border-radius: 3px;
  background-color: #fffbec;

  margin-top: -120px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmblemImage = styled.img`
  height: 60px;

  /* background-color: ${(props) => props.bcolor}; */

  background-color: ${(props) =>
    props.bcolor ? "transparent" : "transparent"};
`;

export const FlagsWrapper = styled.div`
  background-color: #72969b;
  width: 70%;
  padding: 15px 5px;
  border-radius: 5px;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

export const YellowFlag = styled.img`
  width: 25px;
  height: 25px;
`;

export const Flag = styled.img`
  width: 25px;
  height: 25px;
`;

// In MapPage.style.js
export const ZoomWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease;
  transform-origin: center center;
  will-change: transform;
`;
